import React from 'react'
import {AppFormItemProps,AppFormItem} from './AppFormItem'
import {AppSectionTitle} from './AppSectionTitle'
import './index.less'

export interface AppFormSectionProps{
	hidden?:boolean
	colNumber?: number
	labelWidth?: number
	title?: string
	items?:AppFormItemProps[]
	sectionKey?:number
}

export class AppFormSection extends React.Component<AppFormSectionProps>{

	 renderItem = (itemProps: AppFormItemProps,lastItem:boolean) => {
		let tds: any = []
		let colSpan = (itemProps.colSpan - 1) * 3 + 1
		if (itemProps.labelHidden) colSpan++

		if (!itemProps.labelHidden) {
			tds.push(
				<td key={`title`}>
					<label className="app-from-title" data-req={itemProps.req}>
						{itemProps.label || ''}
					</label>
				</td>
			)
		}

		tds.push(<td key={`field`} colSpan={colSpan} style={{ padding: '5px 0' }}><AppFormItem {...itemProps} /></td>)

		if (!lastItem) tds.push(<td key={`split`}></td>)

		return tds
	}

	// 用于最后一行的补位
	renderBlank = (itemCount:number) =>{
		return [<td key="block_blank" colSpan={(itemCount - 1) * 3 + 2}></td>]
	}


	 getRowList = () => {
		let itemList: any[] = this.props.items.filter(i => !i.hidden) || [];
		let rowList: any[] = []
		let colNumber = this.props.colNumber || 1
		let rowsIndex = -1 // 行号
		let rowItemCounts = 0 // 当前行item数量

		itemList.forEach((item:AppFormItemProps) => {
			// 每行的Item数量为0 ，表示就是新的行
			if(rowItemCounts ===0){
				rowsIndex++;
				rowList.push([] as any)
			}

			// colspan计算逻辑：最大不能超过改行剩余的空间
			let colSpan = (item.colSpan||1) > (colNumber-rowItemCounts) ? (colNumber-rowItemCounts) : (item.colSpan||1);
			let lastItem = (rowItemCounts + colSpan === colNumber);
			rowItemCounts = lastItem ? 0: (rowItemCounts + colSpan);
		
			rowList[rowsIndex].push(this.renderItem({...item,colSpan},lastItem))
		});

		// 用于最后一行的补位
		if(rowItemCounts !==0 ) rowList[rowsIndex].push(this.renderBlank(colNumber-rowItemCounts));

		return rowList
	}

	 renderTitle = () => {
		let title = this.props.title || ''
		return title === '' ? <React.Fragment /> : <AppSectionTitle title={title} />
	}

	 renderLayout = () => {
		let colNumber = this.props.colNumber || 1
		let labelWidth = this.props.labelWidth || 70
		let cols = []
		for (let i = 0; i < colNumber; i++) {
			if (i > 0) cols.push(<col key={`${i}_space`} width="20px" />)
			cols.push(<col key={`${i}_lable`} width={`${labelWidth}px`} />)
			cols.push(<col key={`${i}_field`} />)
		}
		return <colgroup>{cols}</colgroup>
	}

	renderSection = () => {
		let rowList = this.getRowList()
		return (
			<div className="app-form-section">
				{this.renderTitle()}
				<table cellPadding="0" cellSpacing="0" style={{ width: '100%' }}>
					{this.renderLayout()}
					<tbody>
						{rowList.map((row: any, index) => {
							return <tr key={index}>{row}</tr>
						})}
					</tbody>
				</table>
			</div>
		)
	}


	render () {
		return this.props.hidden ? null:this.renderSection();
	}
}



// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppFormSection.tsx